import {NgModule} from '@angular/core';
import {LoadingComponent} from '../loader/loading.component';
import { FileSizePipe } from './pipe/filesize.pipe';
import { TokenPopupComponent } from './services/alert/token-popup/token-popup.component';


@NgModule({
  exports: [LoadingComponent, FileSizePipe,TokenPopupComponent ],
  declarations: [LoadingComponent, FileSizePipe, TokenPopupComponent],
})

export class SharedModule {
}


